import theme from "@/styles/novaTheme";
import { css } from "@emotion/react";

export const style = css`
  max-width: 100%;
  overflow: hidden;
  background-color: #f0f3f8;

  .ant-col > img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }

  form .ant-row {
    padding: 1rem;

    h1 {
      margin: 0px;
      color: ${theme.colors.blue400};
    }

    p {
      font-size: 1.3em;
    }

    b {
      font-family: ${theme.fonts.ProximaNovaSbold};
    }

    h3 {
      font-size: 1.6em;
      color: ${theme.colors.blueGray900};
      font-family: ${theme.fonts.ProximaNovaSbold};
    }

    .ant-form-item-control-input-content {
      span {
        font-size: 1.5em;
        font-family: ${theme.fonts.ProximaNovaLight};
      }
    }
  }
`;
